import type {ForestMassRepository} from '@/domain/interfaces/ForestMassRepository';

export class GetAllForestMassUseCase {
  constructor(private readonly repository: ForestMassRepository) {}
  async execute() {
    return this.repository.getAll();
  }
}
